import View from '../View';
import {buildCheckoutShippingSummaryExpression} from './CommerceUtils';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  CommerceOrderWrapperConstraint,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement, type Expression} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

export const createCommerceCheckoutShippingSummaryWrapper: () => Expression =
  () => buildCheckoutShippingSummaryExpression();

const config = createIntegratedAtom({
  displayName: 'Shipping Method',
  showEmpty: true,
  constraints: {
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; } | { ...; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceOrderWrapperConstraint,
      {
        // @ts-expect-error - TS2322 - Type 'string | string[] | UnsafeConstraintEscapeHatch | readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]' is not assignable to type 'string | string[] | UnsafeConstraintEscapeHatch'.
        is: 'CommerceCartWrapper',
        rule: 'Forbid',
      },
    ],
    descendants: [...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
